import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect } from 'react'
import { useLazyGetMemecoinTransactionsByAddressQuery } from '../../../modules/memecoins/api'
import { selectMemecoinTransactions } from '../../../modules/memecoins/selectors'
import { setMemecoinTransactions } from '../../../modules/memecoins/slice'
import { IRootReducer } from '../../../types/reducerTypes'

const usePoolTransactionsByAddress = (
  poolAddress: string,
  ordering: 'desc' | 'asc' = 'desc',
  limit: number = 20,
  offset: number = 0,
  search: string = '',
) => {
  const [fetchTransactions, { isLoading, isFetching }] = useLazyGetMemecoinTransactionsByAddressQuery()
  const dispatch = useDispatch()

  // const cacheKey = `${search}-${ordering}-${limit}-${offset}`
  // 0 offset to insert on first cache list
  // const cacheKey0 = `${search}-${ordering}-${limit}-0`

  const transactions = useSelector((state: IRootReducer) =>
    selectMemecoinTransactions()(state),
  )

  const handleFetchTransactions = useCallback(async () => {
    const { transactions, meta } = await fetchTransactions(
      {
        address: poolAddress,
        ordering,
        limit,
        offset,
        search,
      },
      true,
    ).unwrap()
    dispatch(
      setMemecoinTransactions({
        transactions,
        meta: {
          ...meta,
          poolAddress,
        },
      }),
    )
  }, [
    fetchTransactions,
    poolAddress,
    ordering,
    limit,
    offset,
    search,
    dispatch,
    // cacheKey,
  ])

  useEffect(() => {
    handleFetchTransactions()
  }, [handleFetchTransactions])

  return {
    transactions: transactions?.data,
    meta: transactions?.meta,
    // cacheKey,
    // cacheKey0,
    isLoading,
    isFetching,
  }
}

export default usePoolTransactionsByAddress
